import { useEffect, useRef } from 'react';
import { useFirmBaseLayoutContext } from './FirmBaseLayoutContext';
import type { FirmBaseLayoutNavigationRegistrationToken } from './FirmBaseLayoutContext.types';
import type { SecondaryNavigationState } from './secondaryNavigation.types';

export const useSecondaryNavigationRegistration = (secondaryNavigation: SecondaryNavigationState | null) => {
  // This is shell-state ownership, not a DOM id. Symbol prevents collisions and useRef keeps it stable per route instance.
  const registrationTokenRef = useRef<FirmBaseLayoutNavigationRegistrationToken>(Symbol('secondary-navigation'));
  const registrationToken = registrationTokenRef.current;
  const { clearSecondaryNavigation, registerSecondaryNavigation } = useFirmBaseLayoutContext();

  // Register updates whenever secondaryNavigation changes. registerSecondaryNavigation bails out via
  // areSecondaryNavigationStatesEqual when content is unchanged, preventing spurious context updates.
  useEffect(() => {
    registerSecondaryNavigation(registrationToken, secondaryNavigation);
  }, [registerSecondaryNavigation, registrationToken, secondaryNavigation]);

  // Clear only on unmount so that route-transition cleanup never races with the incoming route's register call.
  // Keeping clear separate prevents the combined cleanup→register cycle from bypassing the bail-out above.
  useEffect(() => () => {
    clearSecondaryNavigation(registrationToken);
  }, [clearSecondaryNavigation, registrationToken]);
};
